import React, { useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { FormInputNew } from 'components/Input/FormInputNew';

interface IProps {
	changeEmailBodyTemplate: (value: string) => void;
}

export const EmailBodyTemplateField: React.FC<IProps> = React.memo(({ changeEmailBodyTemplate }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterEmailBodyTemplate') }], [t]);

	return (
		<FormInputNew
			testId="EmailBodyTemplateField"
			name="emailBodyTemplate"
			label="emailBodyTemplateLabel"
			validationRules={validationRules}
			onChange={changeEmailBodyTemplate}
		/>
	);
});
